import { COMPANIES_PATH } from 'commons/constants/routes'
import { Tooltip } from 'ui/components'
import { CheckMark } from 'ui/components/CheckMark'
import { Icon, IconName, IconSize } from 'ui/components/Icon'
import { TableActions, TableColumn } from 'ui/components/Table'

import { ContactRelatedCompanies } from '../../../../types'

import { NameLink } from './styles'

export const columns = (
  onEdit: (companyId: number) => void,
  onDelete: (contact: ContactRelatedCompanies) => void
): TableColumn<ContactRelatedCompanies>[] => [
  {
    title: 'Company Name',
    render: ({ id, name, isDocuments, isFinancials }) => (
      <NameLink to={`${COMPANIES_PATH}/${id}`}>
        {name}
        {isDocuments && (
          <Tooltip id={`documents${id}`} type="dark" content="Documents" event="hover">
            <Icon name={IconName.DOCUMENT} size={IconSize.XS} />
          </Tooltip>
        )}
        {isFinancials && (
          <Tooltip id={`financials${id}`} type="dark" content="Financials" event="hover">
            <Icon name={IconName.FINANCIALS} size={IconSize.XS} />
          </Tooltip>
        )}
      </NameLink>
    )
  },
  {
    title: 'Title',
    key: 'title'
  },
  {
    title: 'Owner (Ownership %)',
    render: ({ isOwner, showOwnershipPercent }) =>
      isOwner && <CheckMark value rounded label={`${showOwnershipPercent} %`} />
  },
  {
    title: 'Debtholder',
    render: ({ isDebtholder }) => isDebtholder && <CheckMark value rounded label="" />
  },
  {
    title: 'Account Signer',
    render: ({ isAccountSigner }) => isAccountSigner && <CheckMark value rounded label="" />
  },
  {
    title: 'Action',
    width: '50px',
    render: (item: ContactRelatedCompanies) => (
      <TableActions
        items={[
          {
            type: 'edit',
            onClick: () => onEdit(item.id)
          },
          {
            type: 'delete',
            onClick: () => onDelete(item)
          }
        ]}
      />
    )
  }
]
